const styles = (theme) => ({
  infoLabel: {
    margin: theme.spacing(1.75, 0, 0),
    color: theme.color.grey_75,
    textTransform: 'uppercase',
  },
  grid: {
    padding: theme.spacing(1.25, 4),
  },
  shipping: {
    padding: theme.spacing(0, 0, 1.75),
  },
  payment: {
    padding: theme.spacing(2.5, 3, 3.75),
    backgroundColor: theme.color.grey_f6,
  },
  paymentExp: {
    backgroundColor: theme.color.white,
  },
  productWrapper: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  buttonGrid: {
    borderTop: `1px solid ${theme.color.grey_e1}`,
    padding: theme.spacing(1.25, 4),
  },
  service: {
    display: 'flex',
    padding: theme.spacing(1.5, 3),
    justifyContent: 'space-between',
    borderTop: `1px solid ${theme.color.grey_e1}`,
  },
  fullLine: {
    color: theme.color.black_80,
    paddingBottom: theme.spacing(3),
  },
  shippingLine: {
    color: theme.color.black_80,
  },
  deliveryLine: {
    paddingBottom: theme.spacing(1),
  },
  failedText: {
    color: theme.color.black_80,
    paddingTop: theme.spacing(1.5),
  },
  processButton: {
    color: theme.color.black_80,
    backgroundColor: theme.color.white,
    border: `1px solid ${theme.color.grey_e1}`,
    marginTop: theme.spacing(1.5),
  },
});
export default styles;
